<mat-card appearance="outlined" [style.margin-left.px]="operator.parent === null ? 0 : 30">
  @if (operator.parent !== null) {
    <div
    style="
      position: absolute;
      border-left: 2px dashed gray;
      top: 0;
    "
      [style.left.px]="-15"
      [style.height]="isLastSibling ? '25px' : '100%'"
      >
    </div>
  }
  @if (operator.parent !== null) {
<div style="
    position: absolute;
    top: 25px;
    left: -15px;
    width: 15px;
    border-top: 2px dashed gray;
  ">
    </div>
  }
  <mat-card-header>
    <mat-card-title>
      <h3>
        <eas-editor-eligibility-operator-title [operator]="operator"></eas-editor-eligibility-operator-title>&nbsp;
        @if (operator.isShown()) {
          <app-badge variant="success" title="Shown" i18n-title></app-badge>
        }
        @if (!operator.isShown()) {
          <app-badge variant="none" title="Hidden" i18n-title></app-badge>
        }
      </h3>
    </mat-card-title>
    <mat-card-subtitle>
      @if (!operator.hasRule()) {
        <eas-editor-eligibility-operator-children-title
          [childOperators]="operator.children"
          [affirmative]="operator.affirmative"
          [function]="operator.function"
          >
        </eas-editor-eligibility-operator-children-title>
      }
      @if (operator.hasRule()) {
        <eas-editor-eligibility-rule
          [rule]="ruleList[operator.ruleIndex]"
          [affirmative]="operator.affirmative"
          >
        </eas-editor-eligibility-rule>
      }
    </mat-card-subtitle>
    <div class="mat-mdc-card-header-actions">
      <ul class="nav justify-content-end">
        <li class="nav-item">
          <button mat-icon-button
            aria-label="Edit eligibility rule"
            i18n-aria-label
            (click)="onEdit()">
            <mat-icon>edit</mat-icon>
          </button>
        </li>
        <li class="nav-item">
          <button mat-icon-button [matMenuTriggerFor]="itemOptionDropdown" aria-label="Show more rule actions" i18n-aria-label>
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #itemOptionDropdown="matMenu">
            @if (operator.parent !== null) {
              <button mat-menu-item (click)="onAddEmptyRule()" i18n>Add rule</button>
            }
            <button mat-menu-item (click)="onMakeComposite()" i18n>Make composite</button>
            @if (operator.parent !== null) {
              <button mat-menu-item (click)="onMoveUp()" i18n>Move up</button>
            }
            @if (operator.parent !== null) {
              <button mat-menu-item (click)="onMoveDown()" i18n>Move down</button>
            }
            <button mat-menu-item (click)="onDuplicate()" i18n>Duplicate</button>
            @if (operator.parent !== null) {
              <button mat-menu-item (click)="onDelete()" i18n>Delete</button>
            }
          </mat-menu>
        </li>
      </ul>
    </div>
  </mat-card-header>
  <mat-card-content>
    @for (childOperator of operator.children; track childOperator; let isLastChild = $last) {
      <eas-editor-eligibility-operator [operator]="childOperator" [ruleList]="ruleList" [isLastSibling]="isLastChild">
      </eas-editor-eligibility-operator>
      @if (!operator.hasRule() && !isLastChild) {
        <div style="padding: 8px 0">
          {{ operator.function }}
        </div>
      }
    }
  </mat-card-content>
</mat-card>
